import { AccountItemLine } from "./AccountItem";
import { UpgradePlanButton } from "./UpgradePlanButton";
import { getTimeLeftInFreeTrial } from "./utils";
import { useCurrentUser } from "../../hooks";
import AccountStatus from "../layout/header/AccountStatus";

export default function FreePlanSettings() {
  const { data: userData } = useCurrentUser();
  const accountType = userData?.user?.account?.accountType;
  const freeTrialExpiresAt =
    userData?.user?.account?.freeTrialExpiresAt;
  const timeLeft = getTimeLeftInFreeTrial(freeTrialExpiresAt);

  return (
    <div className="flex-1 flex flex-col gap-md">
      <div className="flex items-center justify-between w-full">
        <div className="flex-1 divide-y divide-secondary">
          <AccountItemLine
            title="Plan Type:"
            dataTestId="free-plan-type-line"
          >
            <span className="text-primary">
              {accountType === "basic" && !timeLeft.isExpired
                ? `You are currently on a Free Trial with ${timeLeft.formattedTime}.`
                : "You are currently on the Free Plan."}
            </span>
          </AccountItemLine>
          <AccountItemLine
            title="Feature Access:"
            dataTestId="free-plan-feature-access-line"
          >
            <div className="flex flex-col md:flex-row items-center text-center md:text-left gap-sm">
              <AccountStatus small />

              <span className="text-secondary text-xs md:text-sm">
                {accountType === "basic" && !timeLeft.isExpired
                  ? "Upgrade your account to keep using all features after your trial ends."
                  : "Upgrade your account to access all Scribenote features."}
              </span>
            </div>
          </AccountItemLine>
        </div>
        <div id="accountSubscriptionOptions" className="ml-lg">
          <UpgradePlanButton featureName="Free Plan Settings" />
        </div>
      </div>
    </div>
  );
}
